import $ from 'jquery';
import Variables from './App/Variables';
import Utility from './App/Utility';
import FlyoutImageMenu from './App/FlyoutImageMenu';
import Prefetch from './App/Prefetch';

window.jQuery = window.$ = $;

const App = (() => ({
    Variables,
    Utility,
    Prefetch,
    FlyoutImageMenu,
    initialize: () => {
        $(document).ready(function () {
            Variables.initialize();
            Utility.initialize();
            FlyoutImageMenu.initialize({
                nav: '#site-navigation',
                image: {
                    left: 'data-flyout-image-left',
                    right: 'data-flyout-image-right',
                },
            });
            $('body').on('click', '.errorHide', function () {
                $(".woocommerce-error").fadeOut();
            });

            // hide woocommerce-messages after x seconds
            setTimeout(function () {
                $('.woocommerce-message, .woocommerce-info, .woocommerce-error').fadeOut();
            }, 4000);
        });

        var windowWidth = $(window).width();
        var windowMinWidth = 1125;
        var menuDefaultPosition = $("header").height();

        var changeMenue = function () {
            if (windowWidth >= windowMinWidth) {
                if ($(document).scrollTop() >= (menuDefaultPosition - 50)) {
                    // var hf_height = $(".wrapper-row-content.header-form").height();
                    // $(".header-video main#content").css('margin-bottom', hf_height + 'px');

                    $("body").addClass("menu-fixed");
                    //$('div#page').css('margin-top', $("#site-navigation").outerHeight() + 'px');
                } else {
                    $("body").removeClass("menu-fixed");
                    //$('div#page').css('margin-top', '0px');
                }
            }
        };

        var bgPrimaryHeadlineAdaption = function () {
            $('.bg-primary').each(function (i, v) {
                if ($(v).find('p').length == 0) {
                    $(v).find('h1, h2, h3, h4, h5, h6').css({
                        'padding-bottom': 0,
                    });
                }
            });
        };

        $(document).scroll(function () {
            changeMenue();
        });


        $(window).load(function () {
            Prefetch.initialize();
            changeMenue();
            bgPrimaryHeadlineAdaption();

        });
    },
}))();

export default App;



// WEBPACK FOOTER //
// ./scripts/App.js